module.exports = __webpack_public_path__ + "img/everett-mcintire-BPCsppbNRMI-unsplash.2f94f581.jpg";